import {
  useQueryClient,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { UserFactor } from "@okta/okta-sdk-nodejs";

import { API_ENROLL_PHONE_FACTOR_URL } from "constants/apiUrls";

import { QueryKey } from "types/queryKey/queryKey";
import { PhoneFactor } from "types/factor/factor";
import { OktaError } from "types/oktaError/oktaError";

import useGetApiClient from "./useGetApiClient";

export type EnrollPhoneData = {
  factorType: PhoneFactor;
  phoneNumber: string;
};

function useEnrollPhoneFactor(): UseMutationResult<
  UserFactor,
  OktaError,
  EnrollPhoneData
> {
  const apiClient = useGetApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      const response = await apiClient(API_ENROLL_PHONE_FACTOR_URL, {
        method: "POST",
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return await response.json();
      }
    },
    onSuccess: () => {
      queryClient.fetchQuery([QueryKey.AllFactors]);
    },
  });
}

export default useEnrollPhoneFactor;
